import { render, staticRenderFns } from "./DepositStatementListItem.vue?vue&type=template&id=0af94f80&lang=pug&"
import script from "./DepositStatementListItem.vue?vue&type=script&lang=js&"
export * from "./DepositStatementListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports